<template>
  <v-dialog
    :value="showDialog"
    width="850"
    persistent
    scrollable
  >
    <v-card>
      <AdCardTitle dialog>{{ $t(mode) }}</AdCardTitle>
      <v-card-text class="pt-4">
          <v-row>
            <v-col>
              <EditableTranslationEditor
                v-model="editableValue"
                :editor="editorType === 'editor'"
                :textarea="editorType === 'textarea'"
                :locales="projectLocales"
                emitOnInput
              />
            </v-col>
          </v-row>
      </v-card-text>

      <v-card-actions class="dialogbottomstrip">
        <v-spacer></v-spacer>
        <AdButton type="cancel" @click="closeModal" />
        <AdButton v-if="value != null && !editorHasText && allowEmptyText" type="erase" @click="erase" />
        <AdButton v-else :type="editorHasText ? 'save' : 'add'" :disabled="!editorHasText" @click="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'EditableRichText',
  props: {
    mode: {
      type: String,
      validator: v => ['edit', 'add'].includes(v),
      default: 'add'
    },
    // Determines the state (open/closed) of the dialiog
    showDialog: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    allowEmptyText: {
      type: Boolean,
      default: false
    },
    editorType: {
      type: String,
      default: 'editor',
      validator: v => ['editor', 'textarea', 'input'].includes(v)
    }
  },
  data () {
    return {
      editableValue: null
    }
  },
  computed: {
    editorHasText () {
      return this.editableValue?.some(v => this.$filters.htmlHasTextContent(v['#text']))
    }
  },
  methods: {
    closeModal () {
      this.$emit('cancel')
      this.editableValue = null
    },
    save () {
      const value = cloneDeep(this.editableValue)
      this.$emit('input', value)
      this.closeModal()
    },
    erase () {
      this.editableValue = null
      this.$emit('input', null)
      this.$emit('cancel')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          this.editableValue = cloneDeep(newValue)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .required .v-label:after {
  content: "*";
  font-weight: bold;
  color: var(--v-error-base);
}
</style>
